import { Colors, Metrics, Helpers, Heading3 } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import { System } from '../../CalculatorResult.types';

const SystemDetailsStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  margin-top: ${Metrics.Spacing.M_Y_SM + 10}px;

  strong {
    font-size: ${Metrics.FontSizes.Large.H3}px;
    display: block;
  }
  span {
    font-size: ${Metrics.FontSizes.BODY}px;
    color: ${Colors.GREY};
    white-space: nowrap;
  }

  .name {
    flex: 1;
    flex-basis: 100%;
    margin-bottom: ${Metrics.Spacing.M_Y}px;
  }

  .inverter,
  .panels {
    display: flex;
    flex: 1;
    width: 50%;
    box-sizing: border-box;

    .details {
      display: inline-block;
    }

    img {
      margin-right: ${Metrics.Spacing.M_X_SM}px;
    }
  }

  .inverter {
    padding-right: ${Metrics.Spacing.M_X_XS}px;
  }

  .panels {
    padding-left: ${Metrics.Spacing.M_X_XS}px;
    border-left: 1px solid ${Colors.GREY16};
  }

  ${Helpers.media.SM`
    .name, .inverter, .panels {
      flex-basis: 50%;
    }
    .inverter, .panels {
      padding-left: ${Metrics.Spacing.M_X_XS}px;
      border-left: 1px solid ${Colors.GREY16};
    }
    .panels {
      position: relative;
      margin-left: auto;
      min-width: 50%;
      flex: 0;
      &:before {
        content: '';
        position: absolute;
        width: 1px;
        height: 100%;
        left: -1px;
        top: -100%;
        background: ${Colors.GREY16};
      }
    }
  `} ${Helpers.media.XL`
    .name, .inverter, .panels {
      flex-basis: auto;
    }
    .name {
      flex: 2;
    }
    .inverter, .panels {
      flex: 1;
    }
    .panels {
      margin: 0;
      min-width: 0;

      &:before {
        display: none;
      }
    }
  `};
`;

export interface SystemDetailsProps {
  system: System;
}

export const SystemDetails: React.SFC<SystemDetailsProps> = ({ system }) => (
  <SystemDetailsStyles>
    <div className="name">
      <Heading3 data-id="systemName" text={system.name} />
      <span>{system.description}</span>
    </div>
    <div className="inverter">
      <img
        src={'https://res.cloudinary.com/originenergy/image/upload/h_48,c_scale/v1548113577/solar/solar_inverter.png'}
      />
      <div className="details">
        <Heading3 data-id="inverterWatts" text={`${system.inverter.watts / 1000} kW`} />
        <span>inverter</span>
      </div>
    </div>
    <div className="panels">
      <img
        src={'https://res.cloudinary.com/originenergy/image/upload/h_48,c_scale/v1548113577/solar/solar_panel.png'}
      />
      <div className="details">
        <Heading3 data-id="panelCount" text={`${system.solarPanels.panelCount}`} />
        <span>solar panels</span>
      </div>
    </div>
  </SystemDetailsStyles>
);
